import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	buttonTitle: {
		id: 'company-hub.carousel-extension.config-panel.layout.title',
		defaultMessage: 'Choose a layout',
		description: 'title for the carousel layout button',
	},
	frameAboveImageLabel: {
		id: 'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label',
		defaultMessage: 'Text with frame above image',
		description: 'Frame above image layout option label',
	},
	splitDesignLabel: {
		id: 'company-hub.carousel-extension.config-panel.layouts.split-design-content.label',
		defaultMessage: 'Split design',
		description: 'Split design layout option label',
	},
	solidColorBackgroundLabel: {
		id: 'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label',
		defaultMessage: 'Solid color background',
		description: 'Solid color background layout option label',
	},
});
